<template>
  <ul class="providers">
    <li
      v-for="(item) in list"
      :key="item.term + item.id"
      class="providers__provider-item"
    >
      <CardProvider class="providers__provider-card" :data="item" is-outline />
    </li>
  </ul>
</template>

<script>
import CardProvider from '@/components/shared/Cards/CardProvider'

export default {
  name: 'ProvidersList',
  components: {
    CardProvider,
  },
  props: {
    list: { type: Array },
  },
}
</script>

<style scoped lang="scss">
.providers {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spaces-m);

  @include media(mobile-last) {
    grid-template-columns: 1fr 1fr;
  }

  @include media(tablet) {
    grid-template-columns: 1fr 1fr 1fr;
    gap: var(--spaces-xl);
  }

  @include media(tablet-album) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  @include media(desktop-mid) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  }
}
</style>
